import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

export interface DownloadFileIconProps {
  size?: number
  fill?: string
}

export const DownloadFileIcon: FunctionComponent<DownloadFileIconProps> = ({ size = 24, fill = 'black' }) => {
  return (
    <Svg width={size} height={size} viewBox='-2 -1 18 18' fill='none'>
      <Path
        d='M7 9.35801V1H8V9.29289L10.1464 7.14645L10.8536 7.85355L7.51386 11.1932L3.91086 7.8674L4.58914 7.1326L7 9.35801ZM2 13V7H1V14H14V7H13V13H2Z'
        fill={fill}
      />
    </Svg>
  )
}
